document.addEventListener("DOMContentLoaded", function() {
    // HEADER TRANSPARENT SUR AUTRES PAGES QUE LA HOME
    // Sélectionner le body
    const body = document.querySelector('body');

    // Vérifier si body contient une des deux classes
    if ( body.classList.contains('template-collection-realisations') || body.classList.contains('template-page-methode') || body.classList.contains('template-page-maison') || body.classList.contains('template-product-realisation') ) {
        // Sélectionner le header avec l'ID "header"
        const header = document.getElementById('header');

        if (header) {
            // Supprimer la classe .transparent--false
            header.classList.remove('transparent--false');

            // Ajouter la classe .transparent--true
            header.classList.add('transparent--true');
        }
    }

    // PRODUIT SINGLE : MASQUER LES BLOCS VIDES
    // Vérifier si le body a la classe .template-product-realisation
      if (document.body.classList.contains('template-product-realisation')) {
        // BLOC SINGLE IMAGE Sélectionner tous les blocs .section-single-image
        var sections = document.querySelectorAll('.section-single-image');

        sections.forEach(function (section) {
          // Vérifier si un enfant de la section porte la classe .thb-placeholder
          if (section.querySelector('.thb-placeholder')) {
            // Masquer le bloc .section-single-image
            section.style.display = 'none';
          }
        });

        // BLOC RICH TEXT Sélectionner tous les blocs .section-rich-text
        var richTextSections = document.querySelectorAll('.section-rich-text');

        richTextSections.forEach(function (section) {
          // Sélectionner la div .rte à l'intérieur de chaque bloc .section-rich-text
          var rteDiv = section.querySelector('.rte');

          // Vérifier si la div .rte est vide (c'est-à-dire si elle n'a pas de contenu)
          if (rteDiv && rteDiv.innerHTML.trim() === '') {
            // Masquer le bloc .section-rich-text si la div .rte est vide
            section.style.display = 'none';
          }
        });

        // BLOC BEFORE AFTER Sélectionner tous les blocs .section-before-after
        var beforeAfterSections = document.querySelectorAll('.section-before-after');

        beforeAfterSections.forEach(function (section) {
          // Sélectionner la div .h3 à l'intérieur de chaque bloc .section-before-after
          var h3Div = section.querySelector('.h3');

          // Vérifier si la div .h3 est vide (c'est-à-dire si elle n'a pas de contenu)
          if (h3Div && h3Div.innerHTML.trim() === '') {
            // Masquer le bloc .section-before-after si la div .h3 est vide
            section.style.display = 'none';
          }
        });

        // BLOC CUSTOM LIQUID Sélectionner tous les blocs .section-custom-liquid
        var customLiquidSections = document.querySelectorAll('.section-custom-liquid');

        customLiquidSections.forEach(function (section) {
          // Sélectionner la div .gallery--inner à l'intérieur de chaque bloc .section-custom-liquid
          var galleryInnerDiv = section.querySelector('.gallery--inner');

          // Vérifier si la div .gallery--inner est vide (c'est-à-dire si elle n'a pas de contenu)
          if (galleryInnerDiv && galleryInnerDiv.innerHTML.trim() === '') {
            // Masquer le bloc .section-custom-liquid si la div .gallery--inner est vide
            section.style.display = 'none';
          }
        });

      }

    const btnsSidePanel = document.querySelectorAll('.side-panel-links button');

    btnsSidePanel.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault;
        const btnParent = btn.closest('.side-panel-links');
        const btnLink = btnParent.querySelector('a:nth-of-type(' + btn.dataset.id + ')');
        const sidePanel = document.querySelector('.side-panel.product-information-drawer');

        if (btnLink) {
          sidePanel.classList.remove('active');
          body.classList.remove('open-cc');
          window.location = btnLink.href;
        }
      });
    });

    // Modifier le comportement du header sticky au scroll
    let lastScrollTop = 0;
    const header = document.getElementById('header'); // Sélectionner le header
    const headerSection = document.querySelector('.header-section'); // Sélectionner le header

    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > lastScrollTop) {
        // Scroll vers le bas : cacher le header
        header.classList.add('header-hidden');
        headerSection.classList.add('header-hidden');
      } else {
        // Scroll vers le haut : montrer le header
        header.classList.remove('header-hidden');
        headerSection.classList.remove('header-hidden');
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Éviter des valeurs négatives

      localStorage.removeItem("661844-dismissed-in-session");
      localStorage.removeItem("661844-dismissed-after-submit");
    });

    /*** Formulaire Prix sur demande ***/
    localStorage.removeItem("661844-dismissed-in-session");
    localStorage.removeItem("661844-dismissed-after-submit");

    const btnRequestPrice = document.getElementById('product-price-request');

	if (btnRequestPrice) {
		var config = { attributes: true, childList: true };

		// Fonction callback à éxécuter quand une mutation est observée
		var callback = function (mutationsList) {
			for (var mutation of mutationsList) {
				if (mutation.type == "attributes") {
					if (mutation.target.dataset.currentStep == "success") {
						btnRequestPrice.setAttribute('disabled', 'disabled');
					}
			    }
			}
		};

		// Créé une instance de l'observateur lié à la fonction de callback
		var observer = new MutationObserver(callback);

		let updateForm = false;

		btnRequestPrice.addEventListener('click', function () {
			localStorage.removeItem("661844-dismissed-in-session");
			localStorage.removeItem("661844-dismissed-after-submit");

			const formRequestPrice = document.getElementById('app-embed-container-661844');

			if (formRequestPrice) {
				const appEmbed = formRequestPrice.shadowRoot.querySelector("#app-embed");

				// Commence à observer le noeud cible pour les mutations précédemment configurées
				observer.observe(appEmbed, config);

				if (!updateForm) {
					const productTitle = document.querySelector('.product-title').innerText;

					let popupTitle = formRequestPrice.shadowRoot.querySelector("h2[class^='_textHeading_']");
					let newTitleEl = document.createElement("span");
					newTitleEl.innerText = productTitle;
					newTitleEl.style.fontSize = '.8em';
					newTitleEl.style.lineHeight = '1';
					newTitleEl.style.fontWeight = '400';
					newTitleEl.style.display = 'block';
					newTitleEl.style.marginTop = '5px';

					popupTitle.appendChild(newTitleEl);

					updateForm = true;
				}

				var style = document.createElement( 'style' );
				style.innerHTML = 'form div:has(input:focus, textarea:focus, label[class*="_inputFilled_"]) > label { top: 15px !important; }';
				appEmbed.appendChild( style );

				formRequestPrice.classList.add('is-active');

				let newButton = document.createElement("span");
				newButton.style.cursor = 'pointer';

				const closeButtonContainer = formRequestPrice.shadowRoot.querySelector("div[class^='_formContainerCloseButtonPosition_']");
				const closeButton = formRequestPrice.shadowRoot.querySelector("div[class^='_formContainerCloseButtonPosition_'] > span");

				newButton.innerHTML = closeButton.innerHTML;

				closeButtonContainer.innerHTML = '';
				closeButtonContainer.appendChild(newButton);

				if (newButton) {
					newButton.addEventListener('click', function (e) {
						formRequestPrice.classList.remove('is-active');
					});
				}


			}
		});
	}
});
